import { Checkbox } from "antd";
import styled, { css } from "styled-components";

export const CustomCheckboxStyle = css`
  &.ant-checkbox-wrapper {
    align-items: center;
  }
  .ant-checkbox-wrapper:hover,
  &.ant-checkbox-wrapper:hover {
    .ant-checkbox-inner {
      border-color: var(--main-color) !important;
    }
  }
  .ant-checkbox:hover {
    border-color: var(--main-color);
    .ant-checkbox-inner {
      border-color: var(--main-color);
    }
  }
  .ant-checkbox-disabled + span {
    color: rgba(255, 255, 255, 0.85) !important;
  }
  .ant-checkbox-disabled .ant-checkbox-inner {
    background: #333336 !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: var(--main-color) !important;
    border-color: var(--main-color) !important;
  }
  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: rgba(255, 255, 255, 0.85);
  }
  .ant-checkbox-indeterminate {
    height: 16px;
    .ant-checkbox-input {
      height: 16px;
    }
    .ant-checkbox-inner {
      display: inline-block;
      background: var(--main-color) !important;

      &::after {
        background: #fff !important;
        height: 1px;
        border-top: 1px solid #fff !important;
      }
    }
  }
  .ant-checkbox-checked::after {
    border-color: var(--main-color) !important;
  }
  .ant-checkbox-inner:target {
    border-color: var(--main-color) !important;
  }
  &.ant-checkbox-wrapper.ant-checkbox-wrapper-in-form-item
    input[type="checkbox"] {
    width: 16px;
    height: 16px;
  }
  .ant-checkbox-inner {
    background: #2c2c31 !important;
    border: 1px solid #3b3e42;
    border-radius: 2px;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  ${CustomCheckboxStyle};
`;
export const StyledCheckboxGroup = styled(StyledCheckbox.Group)`
  ${CustomCheckboxStyle};
  flex-wrap: wrap;
  label {
    height: 22px;
  }
`;
